export default "__VITE_ASSET__BG8QEGmf__"